export const configTEST = {
    configEnv: "TEST",
    authority: 'https://login.microsoftonline.com/7f662590-a593-47e5-a0e9-04a11527245a',
    clientId: 'd660bf46-44ee-4ca8-ad05-8ee5ff6e12a7',
    validateAuthority: true,
    redirectUri: window.location.origin + process.env.PUBLIC_URL,
    navigateToLoginRequestUrl: false,
    groupClaims: ["GG_GDL_APP_RW","GG_GDL_APP_RO"],
    scopes: [
        'user.read',
        'directory.read.all'
    ]
};

export const apiConfigTEST = {
    configEnv: "TEST",
    resourceUri: window.location.origin + process.env.PUBLIC_URL,
    resourceScope: [
        'api://' + configTEST.clientId +'/access_as_user',
        'api://' + configTEST.clientId +'/user_impersonation'
    ]
};

// Dev Env Setup this is test 

const configDev = {
    configEnv: "DEV",
    authority: 'https://login.microsoftonline.com/7f662590-a593-47e5-a0e9-04a11527245a',
    clientId: 'fdcc3b41-478b-44fd-8422-ddfa82327fd0',
    validateAuthority: true,
    redirectUri: window.location.origin + process.env.PUBLIC_URL,
    navigateToLoginRequestUrl: false,
    groupClaims: ["GG_GDL_APP_RW", "GG_GDL_APP_RO"],
    scopes: [
        'user.read',
        'directory.read.all'
    ]
};

const apiConfigDev = {
    configEnv: "DEV",
    resourceUri: window.location.origin + process.env.PUBLIC_URL,
    resourceScope: [
        'api://' + configDev.clientId +'/access_as_user',
        'api://' + configDev.clientId +'/user_impersonation'      
    ]
}

// Prod Env Setup

const configProd = {
    configEnv: "PROD",
    authority: 'https://login.microsoftonline.com/7f662590-a593-47e5-a0e9-04a11527245a',
    clientId: '9d9cfc62-70b9-4ccc-b11a-661536046470',
    validateAuthority: true,
    redirectUri: window.location.origin + process.env.PUBLIC_URL,
    navigateToLoginRequestUrl: false,
    groupClaims: ["GG_GDL_APP_RW", "GG_GDL_APP_RO"],
    scopes: [
        'user.read',
        'directory.read.all'
    ]
};

const apiConfigProd = {
    configEnv: "PROD",
    resourceUri: window.location.origin + process.env.PUBLIC_URL,
    resourceScope: [
        'api://' + configProd.clientId +'/access_as_user',
        'api://' + configProd.clientId +'/user_impersonation'      
    ]
}

export const azureManagementScope = ["https://management.azure.com/user_impersonation"];

export const config = process.env.REACT_APP_ENV === 'production'
    ? configProd : (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development' ? configDev : configTEST);

export const apiConfig = process.env.REACT_APP_ENV === 'production'
    ? apiConfigProd : (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'development' ? apiConfigDev : apiConfigTEST);